<template>
  <Menu 
    :breadcrumb="breadcrumb"
    :routes="routes"
    :title="$t('nomeunidade')"
    :hideMenu="hideMenu" />
  <PageWrapper>
    <RouterView />
  </PageWrapper>
</template>

<script>
import { useRoute } from 'vue-router';
import { computed, watch } from "vue";
import { i18n } from '@/main.js';
import Menu from '@/components/Menu.vue';
import { useBreadcrumbStore } from './stores/breadcrumb';
import PageWrapper from "@/components/pagewrapper.vue";

export default {
  components: {
    Menu,
    PageWrapper
  },
  setup(){

    const { t } = i18n.global;
    const lang = i18n.global.locale == "en" ? "en/" : "";

    const routes = {
      apresentacao: { path: '/apresentacao', title: t('menu.apresentacao'), showOnMenu: true },
      documentacao: { path: '/documentacao', title: t('menu.documentacao'), showOnMenu: true },
      inqueritos: { path: '/inqueritos', title: t('menu.inqueritos'), showOnMenu: true },
      acred: { url: `https://www.uma.pt/${lang}avaliacao-universidade-da-madeira/`, title: t('menu.acred'), showOnMenu: true }, 
      faq: { path: '/faq', title: t('menu.faq'), showOnMenu: true },
    }

    const route = useRoute();
    const hideMenu = computed(() => route.path.match(/\/\w+\/\w+/) !== null);
    const store = useBreadcrumbStore();
    const breadcrumb = computed(() => store.breadcrumb);
  
    watch(route, (to, from) => {
      if(to.name != undefined){
        const { title, path } = routes[to.name]; 
        if(to.params?.id == undefined){
          store.replaceSection(title,path);
        }
      }
    }, { deep: true, immediate: true });

    return { 
      breadcrumb,
      routes,
      hideMenu
    };
  }
}
</script>
